import { useContext } from 'react';
import { Context } from './Context';
export const useAssistant = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useAssistant hook used outside <AssistantProvider />');
    }
    return context;
};
